import React, { Component } from 'react'
import { render } from 'react-dom'

import '../../App.css'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter401 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        4. 確率分布一覧
        </Header>

　ここでは「戦略思考の戦略」の理解のために必要な確率分布の一覧を整理します。

        <Header as='h2'>
        主要確率分布一覧 
        </Header>

<table border="1" className="table_base">
  <tr>
    <th className="th_01">名前</th>
    <th className="th_01">確率密度関数</th>
    <th className="th_01">確率変数</th>
    <th className="th_01">params</th>
    <th className="th_01"><InlineMath>{`\\displaystyle E[x]`}</InlineMath></th>
    <th className="th_01"><InlineMath>{`\\displaystyle V[x]`}</InlineMath></th>
  </tr>
  <tr>
    <td className="td_01">二項分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\binom{n}{k}p^k\\left(1-p\\right)^{n-k}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle k `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle n,p `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle np `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle np(1-p) `}</InlineMath></td>
  </tr>
  <tr>
    <td className="td_01">ポアソン分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{\\lambda^ke^{-\\lambda}}{k!}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle k `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\lambda`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\lambda`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\lambda`}</InlineMath></td>
  </tr>
  <tr>
    <td className="td_01">正規分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{1}{\\sqrt{2\\pi \\sigma^2}}\\exp\\left(-\\dfrac{\\left(x-\\mu\\right)^2}{2\\sigma^2}\\right)`}</InlineMath></td>
    <td className="td_01">x</td>
    <td className="td_01"><InlineMath>{`\\mu,\\sigma`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\mu`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\sigma^2`}</InlineMath></td>
  </tr>
  <tr>
    <td className="td_01">幾何分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle p\\left(1-p\\right)^k`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`k`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`p`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{1-p}{p}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{1-p}{p^2}`}</InlineMath></td>
  </tr>
  <tr>
    <td className="td_01">指数分布</td>
    <th className="td_01"><InlineMath>{`\\lambda e^{-\\lambda x} `}</InlineMath></th>
    <td className="td_01"><InlineMath>{`\\displaystyle x `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\lambda `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{1}{\\lambda} `}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{1}{\\lambda^2} `}</InlineMath></td>
  </tr>
  <tr>
    <td className="td_01">負の二項分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\binom{n+k-1}{k-1}p^n\\left(1-p\\right)^{k}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`k`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`n,p`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{n}{p}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{n\\left(1-p\\right)}{p^2}`}</InlineMath></td>
  </tr>
  <tr>
    <td>ガンマ分布</td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{x^{n-1}\\lambda^{n}}{\\Gamma\\left(n\\right)}e^{-\\lambda x}  \\text{      for x > 0}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`x`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`n,\\lambda`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{n}{\\lambda}`}</InlineMath></td>
    <td className="td_01"><InlineMath>{`\\displaystyle \\dfrac{n}{\\lambda^2}`}</InlineMath></td>
  </tr>
</table>

      </div>
    )   
  }
}

export default Chapter401;
